import { Component, OnInit, Inject } from "@angular/core";
import { WtfAnimations } from "../../../../../../utils/others/core/animations";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { SatService } from "../../../../../../services/sat/sat.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-sat-detail-report",
    templateUrl: "./sat-detail-report.component.html",
    animations: WtfAnimations,
    providers: [SatService],
})
export class SatDetailReportComponent implements OnInit {
    campaignData: any;
    chartData: any;
    campaignId: any;

    dialogTitle = "Cargando ...";
    action: RecordAction;

    loading = true;

    scheme = {
        domain: ["#3498db", "#2ecc71", "#e74c3c"],
    };

    constructor(
        public dialogRef: MatDialogRef<SatDetailReportComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: SatService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.campaignId = data.id;
    }

    ngOnInit(): void {
        this.getData();
    }

    getData() {
        this.service
            .getReportingData(this.campaignId, { type: "sat" })
            .subscribe((result) => {
                const { campaignData, chartData } = result;
                this.dialogTitle = campaignData.campaignName;
                this.campaignData = campaignData;
                this.campaignData.type = this.translateService.instant(
                    this.campaignData.type
                );
                this.chartData = chartData;
                this.chartData.forEach((item) => {
                    item.name = this.translateService.instant(item.name);
                });
                this.loading = !this.loading;
            });
    }

    xAxisFormatting(value) {
        return value % 1 === 0 ? value : "";
    }
}
